import { ReactElement, useCallback } from "react";
import {
  AuthenticationError,
  AxiosResult,
  AxiosResultDefaultError,
} from "../../../api/request2";
import { createFetchContext } from "components/context/FetchContextFactory";
import { getPaginatedData } from "../api";
import {
  LeaveRequestsFilters,
  LeaveRequestsPaginatedResponse,
  ITEMS_PER_PAGE_DEFAULT,
} from "../types";
import { splitDateRangeFilters } from "../dateRangeFilters";

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  LeaveRequestsFilters,
  LeaveRequestsPaginatedResponse,
  AuthenticationError | AxiosResultDefaultError
>();

export function useLeaveRequestsLoader() {
  return useFetch();
}

export const LeaveRequestsLoaderConsumer = FetchConsumer;

export default function LeaveRequestsLoader({ children }: BaseLoaderProps) {
  const request = useCallback(
    async (
      query: LeaveRequestsFilters,
    ): Promise<
      AxiosResult<LeaveRequestsPaginatedResponse, AxiosResultDefaultError>
    > => {
      const limit = query.limit || ITEMS_PER_PAGE_DEFAULT;
      const { dateRange } = splitDateRangeFilters(query.searchParams);

      if (query?.searchParams?.startDate) {
        query.searchParams.startDate = dateRange.startDate;
      }

      if (query?.searchParams?.endDate) {
        query.searchParams.endDate = dateRange.endDate;
      }

      return getPaginatedData({
        page: query.page ?? 1,
        limit,
        searchParams: query.searchParams,
      });
    },
    [],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1, limit: ITEMS_PER_PAGE_DEFAULT }}
      fetchImmediately
    >
      {children}
    </FetchProvider>
  );
}
